import { IconProps } from './types'

export const Gifter = ({ className }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 87 80'
      height='80'
      width='87'
      className={className}
    >
      <g clip-path='url(#clip0_541_1554)'>
        <path
          fill='currentColor'
          d='M51.3564 54.7698H75.7914V51.1748H51.3564V54.7698ZM78.7914 57.7698H48.3564V48.1748H78.7914V57.7698Z'
        />
        <path
          fill='currentColor'
          d='M72.2812 73.9001L74.1562 56.1201L77.1413 56.4201L75.5663 71.2151C75.4013 72.8651 73.9312 74.0651 72.2812 73.9051'
        />
        <path
          fill='currentColor'
          d='M51.5857 71.2102L50.0107 56.4152L52.9957 56.1152L54.8707 73.8952C53.2207 74.0602 51.7507 72.8552 51.5857 71.2052'
        />
        <path
          fill='currentColor'
          d='M64.7109 46.4099C63.0559 46.4099 61.7109 45.0649 61.7109 43.4099V12.1299C63.3659 12.1299 64.7109 13.4749 64.7109 15.1299V46.4099Z'
        />
        <path
          fill='currentColor'
          d='M62.1706 29.045L54.2656 21.445C55.4156 20.25 57.3106 20.215 58.5056 21.36L64.2456 26.88L62.1656 29.04L62.1706 29.045Z'
        />
        <path
          fill='currentColor'
          d='M64.2509 32.6051L62.1709 30.4451L68.4509 24.3951C69.6459 23.2451 71.5409 23.2801 72.6909 24.4751L64.2509 32.6101V32.6051Z'
        />
        <path
          fill='currentColor'
          d='M58.3909 40.825H57.3959C49.2309 40.825 42.5859 34.18 42.5859 26.015C42.5859 21.245 44.8359 17.555 49.4559 14.76C49.5909 6.865 55.9609 0 63.2109 0C70.8659 0 77.0959 6.225 77.0959 13.88C77.0959 14.175 77.0859 14.47 77.0609 14.78C81.7209 17.21 84.5709 21.9 84.5709 27.275C84.5709 34.98 78.4459 40.79 70.3259 40.79H67.4509V37.79H70.3259C76.7359 37.79 81.5709 33.27 81.5709 27.275C81.5709 22.74 79.0009 18.82 74.8609 17.055L73.7959 16.6L73.9659 15.455C74.0559 14.85 74.0959 14.35 74.0959 13.875C74.0959 7.975 69.1109 2.995 63.2109 2.995C58.1309 2.995 52.4559 8.13 52.4559 15.01C52.4559 15.11 52.4609 15.205 52.4709 15.3L52.5309 16.47L51.7109 16.92C47.4759 19.25 45.5909 22.055 45.5909 26.01C45.5909 32.52 50.8859 37.82 57.4009 37.82H58.3959V40.82L58.3909 40.825Z'
        />
        <path
          fill='currentColor'
          d='M22.2661 62.2601C20.1861 62.2601 18.5561 60.9301 18.5561 59.2301L18.5361 19.4951C20.1911 19.4951 21.5361 20.8351 21.5361 22.4951L21.5561 59.0801C21.6661 59.1551 21.9111 59.2601 22.2661 59.2601C22.6211 59.2601 22.8711 59.1551 22.9811 59.0801L22.9611 22.4951C22.9611 20.8401 24.3011 19.4951 25.9561 19.4951L25.9761 59.2301C25.9761 60.9301 24.3461 62.2601 22.2661 62.2601Z'
        />
        <path
          fill='currentColor'
          d='M17.4012 5.50988V11.3949C17.4012 12.4099 17.8012 13.3599 18.5162 14.0799C19.2312 14.7949 20.1862 15.1899 21.1962 15.1899H23.2913C25.3863 15.1899 27.0862 13.4849 27.0862 11.3899V5.50488H17.4012V5.50988ZM21.2013 18.1899C19.3863 18.1899 17.6813 17.4849 16.3963 16.1999C15.1113 14.9149 14.4062 13.2099 14.4062 11.3949V2.50988L30.0862 2.50488V11.3899C30.0912 15.1349 27.0463 18.1849 23.2963 18.1899H21.2063H21.2013Z'
        />
        <path
          fill='currentColor'
          d='M32.1007 64.3351V54.1101L28.5107 53.9351C28.5907 52.2801 29.9957 51.0051 31.6507 51.0851L35.0907 51.2501V64.3301H32.0957L32.1007 64.3351Z'
        />
        <path
          fill='currentColor'
          d='M28.9609 73.11C31.0159 70.55 32.1009 67.515 32.1009 64.335H35.1009V64.88H35.0909C35.0059 67.425 34.3209 69.94 33.1209 72.22C32.3109 73.755 30.3159 74.2 28.9609 73.11Z'
        />
        <path
          fill='currentColor'
          d='M9.43578 64.345L9.42578 51.265L13.0708 51.09C14.7258 51.01 16.1308 52.285 16.2108 53.94L12.4258 54.125V64.345H9.43078H9.43578Z'
        />
        <path
          fill='currentColor'
          d='M11.4357 72.26C10.1307 69.805 9.43066 67.08 9.43066 64.335H12.4307C12.4307 67.515 13.5157 70.55 15.5707 73.11C14.2307 74.185 12.2407 73.775 11.4357 72.26Z'
        />
        <path
          fill='currentColor'
          d='M12.4307 64.335H9.43066V64.88H12.4307V64.335Z'
        />
        <path
          fill='currentColor'
          d='M84.006 79.1499H0.000976562C0.000976562 77.4949 1.34598 76.1499 3.00098 76.1499H87.006C87.006 77.8049 85.661 79.1499 84.006 79.1499Z'
        />
      </g>
      <defs>
        <clipPath id='clip0_541_1554'>
          <rect fill='white' height='79.15' width='87.005' />
        </clipPath>
      </defs>
    </svg>
  )
}
